<template>
  <app-layout>
    <div
      class="min-h-screen py-12 px-4 sm:px-6 lg:px-8 flex flex-col justify-center items-center"
    >
      <p class="text-3xl text-center mt-5 mb-0">
        <i
          class="fas fa-check-circle text-green-500 mr-2"
        />
        Thank you for your purchase!
      </p>

      <p class="text-xl text-center mt-2">
        It may take a few minutes for your plan <br />to be
        activated.
      </p>

      <router-link to="/project" class="mt-5 text-blue-600">
        View your projects
      </router-link>
    </div>
  </app-layout>
</template>

<script>
export default {
  async created() {
    setTimeout(() => {
      if (window.fbq) {
        window.fbq('track', 'Purchase', {
          value: 187,
          currency: 'USD',
        });
      }
    }, 100);
  },
};
</script>

<style></style>
